<app-navbar></app-navbar>
<div class="container-fluid">
    <!-- Filtros -->
    <div class="card shadow-sm filtros-modernas border-0 mb-4">
        <div class="card-header d-flex align-items-center rounded-top">
            <i class="fas fa-chart-line fs-5 me-2 text-white"></i>
            <h2 class="fw-bold">Relatório de Vistorias</h2>
        </div>
        <div class="card-body">
            <!-- Linha com botão de filtro à esquerda e controles de paginação/itens por página à direita -->
            <div class="row mt-3" *ngIf="!erro">
                <div class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between">
                    <!-- Botões Filtrar e Exportar Excel -->
                    <div class="d-flex gap-2">
                        <button class="btn btn-info btn-sm" type="button" (click)="showFiltros = !showFiltros">
                            <i class="fas fa-filter me-1"></i> Filtrar
                        </button>
                        <button class="btn btn-success btn-sm" type="button" (click)="exportarParaExcel()" 
                                [disabled]="servicosFiltrados.length === 0"
                                title="Exportar dados filtrados para Excel">
                            <i class="fas fa-file-excel me-1"></i> Exportar Excel
                        </button>
                    </div>

                    <div class="d-flex align-items-center gap-2 me-3">
                        <input class="form-control form-control-sm period-input" type="date"
                            [(ngModel)]="filtroDataInicio" />
                        <span>até</span>
                        <input class="form-control form-control-sm period-input" type="date"
                            [(ngModel)]="filtroDataFim" (change)="onFiltroDataFimChange()"/>
                        <!-- Badge sutil com total ao lado do período -->
                        <span class="badge-total-sutil ms-2" *ngIf="totalRegistros !== null">
                          <i class="fas fa-list me-1"></i> {{ totalRegistros }}
                        </span>
                        <button class="btn btn-primary ms-2" (click)="aplicarFiltro()">
                            <i class="fas fa-sync-alt me-1"></i> Recarregar
                        </button>
                    </div>
                </div>
            </div>
            <div class="row mt-2" *ngIf="showFiltros">
                <div class="col-md-3">
                    <label class="form-label">Status</label>
                    <select class="form-select" [(ngModel)]="filtroStatus">
                        <option value="Concluida">Concluído</option>
                        <option value="Negada">Negado</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label">Matrícula</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroMatricula"
                        placeholder="Matrícula do consumidor" />
                </div>

                <div class="col-md-3">
                    <label class="form-label">Nome Consumidor</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroNomeConsumidor"
                        placeholder="Nome do consumidor" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">CPF</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroCpf" placeholder="CPF" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">CNPJ</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroCnpj" placeholder="CNPJ" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">CEP</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroCep" placeholder="CEP" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Número</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroNumero"
                        placeholder="Número (logradouro)" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Logradouro</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroLogradouro" placeholder="Logradouro" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Bairro</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroBairro" placeholder="Bairro" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Cidade</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroCidade" placeholder="Cidade" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Estado</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroEstado" placeholder="Estado" />
                </div>
                <div class="col-12 mt-2 d-flex gap-2">
                    <button class="btn btn-primary" (click)="aplicarFiltro()">Aplicar filtros</button>
                    <button class="btn btn-secondary" (click)="resetarERecarregar()">Limpar e Recarregar</button>
                </div>
            </div>
        </div>
    </div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
        <p style="color: white"> Processando, por favor aguarde... </p>
    </ngx-spinner>
    <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
        <i class="bi bi-exclamation-triangle-fill"></i> {{ erro }}
    </div>
    <div *ngIf="!carregando && !erro && servicosFiltrados.length === 0"
        class="alert alert-warning d-flex align-items-center gap-2">
        <i class="bi bi-folder-x"></i>
        Nenhuma vistoria encontrada para o filtro selecionado.
    </div>
    <div class="table-responsive" *ngIf="!carregando && !erro && servicosFiltrados.length > 0">
        <table class="table table-bordered table-hover align-middle">
            <thead class="table-light">
                <tr>
                    <th>Data</th>
                    <th style="min-width: 110px;">Nº Vistoria</th>
                    <th>Consumidor</th>
                    <th style="min-width: 130px;">CPF/CNPJ</th>
                    <th style="min-width: 120px;">Tipo Vistoria</th>
                    <th>Status</th>
                    <th>Endereço</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let servico of servicosFiltrados; let i = index; trackBy: trackByServico"
                    [class]="i % 2 === 0 ? 'linha-par' : 'linha-impar'">
                    <td>
                        <span class="text-primary fw-bold">
                            <ng-container *ngIf="getDataVistoria(servico) !== '-'; else semData">
                                {{ getDataVistoria(servico) | date:'dd/MM/yyyy' }}
                            </ng-container>
                            <ng-template #semData>-</ng-template>
                        </span>
                    </td>
                    <td>
                        <span class=" n-vistoria" title="{{ formatNumeroOS(servico) }}">{{ formatNumeroOS(servico) }}</span>
                    </td>
                    <td>
                        <span class="fw-bold text-dark">{{ servico.nomeConsumidor || servico.nome || 'Não informado' }}</span>
                    </td>
                    <td>
                        <span>{{ formatCpfOuCnpj(servico.cpfOuCnpj || servico.cpf || servico.cnpj) }}</span>
                    </td>
                    <td>
                        <span class="badge"
                            [ngClass]="servico.tipoOS === 'Recadastro' ? 'recadastro-badge' : 'cadastro-badge'">
                            {{ servico.tipoOS || 'Cadastro' }}
                        </span>
                    </td>
                    <td>
                        <span *ngIf="servico.statusOS === 'Concluida'" class="badge-concluida text-white">
                            <i class="fas fa-check"></i>
                            Concluído
                        </span>
                        <span *ngIf="servico.statusOS === 'Negada'" class="badge-negada text-white">
                            <i class="fas fa-times"></i>
                            Negado
                        </span>
                    </td>
                    <td>
                        <span class="text-muted">{{ getEnderecoCompleto(servico) }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
